import "./sprinkles.css.ts.vanilla.js";
import "./checkbox.css.ts.vanilla.js";
var r = {
    ios: "_1rz9b14 _1rz9b13 _1y2v1nf5j _1y2v1nf5r _1y2v1nf5x _1y2v1nf60 _1y2v1nf9i _1y2v1nf2p",
    rest: "_1rz9b15 _1rz9b13 _1y2v1nf5j _1y2v1nf5r _1y2v1nf5x _1y2v1nf60 _1y2v1nf9i _1y2v1nf2p",
    checked: "_1rz9b16 _1rz9b13 _1y2v1nf5j _1y2v1nf5r _1y2v1nf5x _1y2v1nf60 _1y2v1nf9i _1y2v1nf2p"
}, n = "_1rz9b18 _1y2v1nf5k", f = "_1rz9b19", y = "_1rz9b11 _1y2v1nf5l", b = "_1rz9b1a";
export { r as boxVariant, n as check, f as checkChecked, y as checkboxContainer, b as disabled };
